import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { css } from '@emotion/react';
import { BirdiTheme, breakpoints } from '@birdi/theme';
import { useMetaSelector } from '../../meta/reducer';
import {
  stroot,
  subscription as subscriptionAPI,
  organisation as orgAPI,
} from '@birdi/js-sdk';

const workspacesBadgeStyle = (theme: BirdiTheme) => css`
  display: flex;
  // width: fit-content;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  background-color: ${theme.lightOcean};
  border-radius: 5px;
  @media (max-width: ${breakpoints.m}) {
    margin: 0;
  }
`;

interface WorkspacesBadgeProps {
  workspacesUsed: number;
  workspacesLimit: number;
}

/**
 * This component shows how many workspaces used and the limit
 */
export const WorkspacesBadge = ({
  workspacesUsed,
  workspacesLimit,
}: WorkspacesBadgeProps) => {
  const navigate = useNavigate();
  const meta = useMetaSelector();

  return (
    <div>
      <div css={workspacesBadgeStyle}>
        <span
          css={css`
            margin-right: 1em;
          `}
        >{`Workspaces   ${workspacesUsed}/${workspacesLimit} used`}</span>

        <button
          type="button"
          css={(theme: BirdiTheme) => css`
            color: ${theme.deepOcean};
            text-decoration: underline;
          `}
          onClick={() => navigate('/billing/options')}
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};
